import logo from "../../resource/7.png";
import CommonFormFields from "./CommonFormFields";
import useFormHandler from "../../Hook/useFormHandler";

const AnnualMembershipForm = () => {
  const initialValues = {
    // Personal Information
    firstName: "",
    lastName: "",

    // Address Information
    address: "",
    city: "",
    postal_code: "",
   

    // Contact Information
    mobileNumber: "",
    wtNumber: "", // This will map to whatsapp_number
    email: "",

    donation_purpose: "",
       other_purpose:"",

    ip_address: "",
  };
  const validations = {
    // Personal Information
    firstName: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "First Name should contain only letters, spaces, or hyphens",
    },
    lastName: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Last Name should contain only letters, spaces, or hyphens",
    },

    // Address Information
    address: {
      required: true,
      minLength: 5,
      message: "Address must be at least 5 characters long",
    },
    city: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "City should contain only letters, spaces, or hyphens",
    },
    postal_code: {
      required: true,
      pattern: /^\d{5,10}$/,
      message: "Postal Code should be 5 to 10 digits",
    },

    // Contact Information
    mobileNumber: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Mobile Number should be 10 to 15 digits, with optional '+'",
    },
    wtNumber: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "WhatsApp Number should be 10 to 15 digits, with optional '+'",
    },
    email: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },

    donation_purpose: {
      required: true,
      validate: (value) =>
        ["birthday", "wedding_anniversary", "punyanumoda", "other"].includes(value) ||
        "Please select one",
    },
  };

  const endpoint = '/create-annual-expense-fund-memberships';

  const transformForApi = (data) => ({
    // Personal Information
    first_name: data.firstName,
    last_name: data.lastName,

    // Address Information
    address: data.address,
    city: data.city,
    postal_code: data.postal_code,

    // Contact Information
    mobile_number: data.mobileNumber,
    phone_with_country_code: data.wtNumber,
    email_address: data.email,

    // Additional Information
    donation_purpose: data.donation_purpose,
    other_purpose:data.other_purpose,
    ip_address: data.ip_address,
  });

  const {
    formData,
    errors,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
  } = useFormHandler({
    initialValues,
    validations,
    endpoint,
    includeIP: true,
    transformFn: transformForApi,
  });
  return (
    <div className="form-page dark-gold ">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Annual Expense Fund – Membership Form </h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Please fill in the following details and we will contact you.
        </p>
        <p className="font-p mt-5">Full Name *</p>

        {/* Common form fields */}
        <CommonFormFields
          formData={formData}
          handleInputChange={handleInputChange}
          errors={errors}
        />

        <p className="font-p mt-5">Address *</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Full Address</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City *</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal Code *</label>
            {errors.postal_code && (
              <span className="error">{errors.postal_code}</span>
            )}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate the purpose or event of significance for the Annual
          Expense Fund donation
        </p>

        <div className="selection mt-5">
          <div className="checkbox-box">
            <label htmlFor="birthday"> Birthdays</label>
            <input
              type="radio"
              id="birthday"
              name="donation_purpose"
              value="birthday"
              className="checkbox"
              checked={formData.donation_purpose === "birthday"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="wedding_anniversary"> Wedding Anniversary</label>
            <input
              type="radio"
              id="wedding_anniversary"
              name="donation_purpose"
              value="wedding_anniversary"
              className="checkbox"
              checked={formData.donation_purpose === "wedding_anniversary"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="punyanumoda"> Punyanumoda (Diseased)</label>
            <input
              type="radio"
              id="punyanumoda"
              value="punyanumoda"
              name="donation_purpose"
              className="checkbox"
              checked={formData.donation_purpose === "punyanumoda"}
              onChange={handleInputChange}
            />
          </div>

          <div className="checkbox-box">
            <label htmlFor="other"> Other</label>
            <input
              type="radio"
              id="other"
              value="other"
              name="donation_purpose"
              className="checkbox"
              checked={formData.donation_purpose === "other"}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {formData.donation_purpose === "other" && (
          <div className="form-box1 mt-5">
            <div className="form-item1">
              <label htmlFor="#">Other</label>
              <input
                type="text"
                id="other_purpose"
                name="other_purpose"
                value={formData.other_purpose}
                onChange={handleInputChange}
              />
            </div>
          </div>
        )}

        {/* Submit button */}
        <button
          type="submit"
          id="submitbtn"
          className="mt-5"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
        <p className="font-p mt-5">
          We greatly appreciate your interest in joining the Annual Expense Fund
          at Bhaddeka Vihari Monastery.
        </p>
      </form>
    </div>
  );
};

export default AnnualMembershipForm;
